<script lang="ts" setup>
import MButton from "../../MButton";
import { QuickAction } from "./types";

withDefaults(
  defineProps<{
    label?: string;
    actions: QuickAction[];
  }>(),
  {
    label: "Quick Actions",
  },
);
</script>

<template>
  <div class="flex flex-col gap-1">
    <h4>{{ label }}</h4>
    <div class="flex flex-wrap gap-1">
      <m-button
        v-for="action in actions"
        :key="action.name"
        :label="action.label"
        color="secondary"
      />
    </div>
  </div>
</template>
